import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MobileContextService, ContextoPWA } from '../services/mobile-context.service';

@Component({
  selector: 'app-mobile-context-bar',
  templateUrl: './mobile-context-bar.component.html',
  styleUrls: ['./mobile-context-bar.component.scss']
})
export class MobileContextBarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  contexto: ContextoPWA | null = null;

  constructor(private contextService: MobileContextService) {}

  ngOnInit(): void {
    this.contextService.contexto$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(contexto => {
      this.contexto = contexto;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  alterarContexto(): void {
    // Implementar modal ou navegação para alterar contexto
  }
}